import styled from 'styled-components';

export const FooterDiv = styled.footer`
	background-color: #2f4159;
	padding: 20px;
	color: #fff;
	display: flex;
	flex-direction: row;

	@media only screen and (max-width: 600px) {
		flex-direction: column;	
	}
`;

export const Column = styled.div`
	width: 33.33%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: ${props => props.first ? 'center' : `none`};

	@media only screen and (max-width: 600px) {
		width: 100%;
		justify-content: unset;
		align-items: center;
	}
`;

export const Copyright = styled.h2`
	margin-top: 20px;
	text-align: center;
`;

export const Title = styled.h1`
	text-align: left;
	font-weight: bold;
	margin-bottom: 20px;
`;

export const MapImage = styled.img`
	width: 80%;
	height: auto;
	display: block;
	margin: 10px auto;
`

export const InfoDiv = styled.div`
	padding: 10px;
	margin: 5px 0;
	display: flex;
	flex-direction: row;
	align-items: center;

	@media only screen and (max-width: 600px) {
		width: 100%;
		justify-content: unset;
		align-items: center;
	}
`;

export const Icon = styled.img`
	width: 10%;
	height: auto;
	margin-right: 20px;
`;

export const Info = styled.h2`
	text-align: left;
	width: 90%;
	font-weight: bold;
`;

export const Links = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
`;

export const Link = styled.a`
	width: 50%
`;

export const LinkImage = styled.img`
	width: 90%;
	height: auto;
	padding: 5%;
`;

